let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("fliVL"), load("181PN")]).then(() => parcelRequire('2i4Yq'));